import React from "react";
import { Link } from "react-router-dom";
import { FalkeTekLogo } from "../components/Brand";
import { ArrowLeft } from "lucide-react";

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-falke-warmwhite" data-testid="datenschutz-page">
      <header className="px-6 py-5 bg-white border-b border-falke-blue/10">
        <div className="max-w-3xl mx-auto flex items-center justify-between">
          <FalkeTekLogo />
          <Link to="/" className="text-falke-blue/70 hover:text-falke-orange inline-flex items-center gap-1 text-sm">
            <ArrowLeft size={14} /> Zurück
          </Link>
        </div>
      </header>

      <div className="max-w-3xl mx-auto px-6 py-12 text-falke-anthracite/85 leading-relaxed">
        <h1 className="text-4xl font-heading font-bold text-falke-blue mb-8">Datenschutzerklärung</h1>

        <p className="mb-6">Wir freuen uns über Ihr Interesse an unserer Empfehlungs-App. Der Schutz Ihrer personenbezogenen Daten ist uns ein wichtiges Anliegen. Im Folgenden informieren wir Sie über die Verarbeitung Ihrer Daten gemäß Art. 13 DSGVO.</p>

        <h2 className="text-xl font-heading text-falke-blue mt-8 mb-3">1. Verantwortlicher</h2>
        <p>
          FalkeTek GmbH<br />
          Friedrich-Ebert-Straße 123<br />
          52531 Übach-Palenberg<br />
          E-Mail: <a href="mailto:info@falke-tek.de" className="text-falke-orange hover:underline">info@falke-tek.de</a><br />
          Telefon: +49 2451 9329167
        </p>

        <h2 className="text-xl font-heading text-falke-blue mt-8 mb-3">2. Erhebung und Verarbeitung personenbezogener Daten</h2>
        <p>Bei der Nutzung der App verarbeiten wir folgende Daten:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li><strong>Registrierungsdaten:</strong> Name, E-Mail, Telefonnummer, Anlagenadresse</li>
          <li><strong>Empfehlungsdaten:</strong> Name + Kontaktdaten der von Ihnen empfohlenen Person (mit deren Einwilligung)</li>
          <li><strong>Gewerbedaten</strong> (bei Gewerblichen Tippgebern): Firmenname, Steuernummer, USt-ID, Gewerbeschein</li>
          <li><strong>Transaktionsdaten:</strong> FalkeCoin-Buchungen, Geschenk-Einlösungen, Provisionsabrechnungen, Shop-Bestellungen</li>
          <li><strong>Technische Daten:</strong> IP-Adresse (anonymisiert), Browser-Typ, Zeitstempel</li>
        </ul>

        <h2 className="text-xl font-heading text-falke-blue mt-8 mb-3">3. Rechtsgrundlage</h2>
        <p>Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. a DSGVO (Einwilligung), insbesondere für die Empfehlungs-Funktion und die Erteilung von Push-Benachrichtigungen.</p>

        <h2 className="text-xl font-heading text-falke-blue mt-8 mb-3">4. Empfänger / Auftragsverarbeiter</h2>
        <p>Folgende Dienstleister verarbeiten Daten in unserem Auftrag (Auftragsverarbeitung nach Art. 28 DSGVO):</p>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li><strong>Resend</strong> (Versand transaktionaler E-Mails wie Magic-Link-Login)</li>
          <li><strong>PayPal (Europe) S.à r.l. et Cie, S.C.A.</strong> (Zahlungsabwicklung im Shop)</li>
          <li><strong>Reonic GmbH</strong> (Service-Kalender)</li>
          <li><strong>Hosting-Provider</strong> für App-Betrieb und Datenbank</li>
        </ul>

        <h2 className="text-xl font-heading text-falke-blue mt-8 mb-3">5. Speicherdauer</h2>
        <p>Wir speichern personenbezogene Daten nur so lange, wie es für den jeweiligen Zweck erforderlich ist. Steuerrelevante Daten (Gutschriften, Rechnungen, Provisionsabrechnungen) bewahren wir entsprechend der gesetzlichen Aufbewahrungsfristen (i. d. R. 10 Jahre nach § 147 AO) auf.</p>

        <h2 className="text-xl font-heading text-falke-blue mt-8 mb-3">6. Ihre Rechte</h2>
        <p>Sie haben jederzeit das Recht auf:</p>
        <ul className="list-disc pl-6 mt-2 space-y-1">
          <li>Auskunft über Ihre gespeicherten Daten (Art. 15 DSGVO)</li>
          <li>Berichtigung unrichtiger Daten (Art. 16 DSGVO)</li>
          <li>Löschung Ihrer Daten (Art. 17 DSGVO), sofern keine gesetzlichen Aufbewahrungsfristen entgegenstehen</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)</li>
          <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft</li>
          <li>Beschwerde bei einer Aufsichtsbehörde (für NRW: LDI NRW, <a href="https://www.ldi.nrw.de" className="text-falke-orange hover:underline" target="_blank" rel="noreferrer">www.ldi.nrw.de</a>)</li>
        </ul>

        <h2 className="text-xl font-heading text-falke-blue mt-8 mb-3">7. Cookies und lokale Speicherung</h2>
        <p>Diese App verwendet ausschließlich technisch notwendige Cookies (Session-Cookie für Login, lokaler Speicher für Anzeigeeinstellungen). Es findet kein Tracking durch Dritte statt.</p>

        <h2 className="text-xl font-heading text-falke-blue mt-8 mb-3">8. Push-Benachrichtigungen</h2>
        <p>Sie können in der App Push-Benachrichtigungen aktivieren. Die Aktivierung erfolgt freiwillig und kann jederzeit in den App-Einstellungen sowie über Ihren Browser widerrufen werden.</p>

        <h2 className="text-xl font-heading text-falke-blue mt-8 mb-3">9. Empfehlungs-Funktion</h2>
        <p>Wenn Sie eine Person empfehlen, bestätigen Sie zugleich, dass diese Person ihrer Kontaktaufnahme durch FalkeTek zugestimmt hat. Die Daten des Empfohlenen werden nur für die Bearbeitung der Empfehlung und die ggf. resultierende Kundenbeziehung verarbeitet.</p>

        <p className="mt-10 text-sm text-falke-anthracite/60">Stand: Februar 2026</p>

        <div className="mt-10 text-center">
          <Link to="/impressum" className="text-falke-orange hover:underline mr-6" data-testid="link-impressum">Impressum</Link>
          <Link to="/" className="text-falke-blue/70 hover:text-falke-orange">Zurück zur App</Link>
        </div>
      </div>
    </div>
  );
}
